import { useState, useEffect } from 'react'
import Popup from 'reactjs-popup';

export default function TabCalculator() {

  //defaults
  const eff = "0.45";
  const area = "0";
  const sqm = "1";

  const [unitLength, setUnitLength] = useState("");
  const [unitWidth, setUnitWidth] = useState("");
  const [waveHeight, setWaveHeight] = useState("");
  const [wavePeriod, setWavePeriod] = useState("");
  const [efficiency, setEfficiency] = useState(eff);

  //Calculated Values
  const [waveLength, setWaveLength] = useState("0");
  const [waveVelocity, setWaveVelocity] = useState("0");
  const [wavePower, setWavePower] = useState("0");
  const [wmInput, setWmInput] = useState("0");
  const [wmOutput, setWmOutput] = useState("0");
  const [wmDaily, setWmDaily] = useState("0");
  const [wmAnnual, setWmAnnual] = useState("0");
  const [deckArea, setDeckArea] = useState("0");   
  const [solarOutput, setSolarOutput] = useState("0");
  const [totalDaily, setTotalDaily] = useState("0");
  const [totalAnnual, setTotalAnnual] = useState("0");
  const [wmIdle, setWmIdle] = useState("0");  
  const [wmRatio, setWmRatio] = useState("0"); 
  
  //Validation Errors
  const [unitLengthErr, setUnitLengthErr] = useState(false);
  const [unitWidthErr, setUnitWidthErr] = useState(false);
  const [waveHeightErr, setWaveHeightErr] = useState(false);
  const [wavePeriodErr, setWavePeriodErr] = useState(false);
  const [efficiencyErr, setEfficiencyErr] = useState(false);
  const [solarAreaErr, setSolarAreaErr] = useState(false);
  const [solarSqMeterErr, setSolarSqMeterErr] = useState(false);

  //Solar
  const [selectedSolar, setSelectedSolar] = useState('no');
  const [solarArea, setSolarArea] = useState(area);
  const [solarSqMeter, setSolarSqMeter] = useState(sqm);

  const handleDeckArea = (l,w) => {     
    let deckAr = Math.round( l * w * 100) / 100;

    if (!isNaN(deckAr))
      setDeckArea(deckAr);      
  }

  const handleUnitLength = (event) => {
    setUnitLength(event.target.value);
    handleDeckArea(event.target.value, unitWidth);
  };  

  const handleUnitWidth = (event) => {
    setUnitWidth(event.target.value);
    handleDeckArea(unitLength, event.target.value);
  };    

  useEffect(() => {
     
    if(isValue(wavePower) && isValue(unitLength) && isValue(waveLength) && isValue(unitWidth) && isValue(efficiency)) {

      let ratio = Math.round((unitLength/waveLength) * 100) / 100;  
      if (!isNaN(ratio)) 
        setWmRatio(ratio);
        
      let waveInp = Math.round(wavePower * unitWidth * (ratio) * 100) / 100;
      if (!isNaN(waveInp))
        setWmInput(waveInp);

      let WmOut = Math.round(waveInp * efficiency * 100) / 100;
      if (!isNaN(WmOut))
        setWmOutput(WmOut);
      let WmDaily = Math.round(WmOut * 24 * 100) / 100 / 1000; 
      if (!isNaN(WmDaily))   
        setWmDaily(WmDaily);
      let WmAn = Math.round(WmDaily * 365 * 100) / 100 ;
      if (!isNaN(WmAn))  
        setWmAnnual(WmAn);

      let idle = Math.round((waveLength - unitLength)/waveVelocity);
      if (!isNaN(idle))  
        setWmIdle(idle > 0 ? idle : 0);
  
    }
    else{
      setWmRatio(0);
      setWmInput(0);
      setWmOutput(0);
      setWmDaily(0);
      setWmAnnual(0);
    }
    
  }, [wavePower, unitLength, unitWidth, efficiency])

  useEffect(() => {
    if(isValue(solarArea) && isValue(solarSqMeter))
      calculateSolar();   
   
  }, [solarArea, solarSqMeter])

  useEffect(() => {
    
    let totD = Math.round( (wmDaily + solarOutput/ 1000) * 100) / 100 ;
    if (!isNaN(totD)) 
    setTotalDaily(totD);  

    let totA = Math.round((wmDaily + solarOutput/ 1000) * 365 * 100) / 100 ;
    if (!isNaN(totA)) 
    setTotalAnnual(totA);    
   
  }, [wmDaily, solarOutput])

   
  const copyToSpArea = () => {
    setSolarArea(deckArea);
  }

  const isValue = (str) => {
    return !(str.length === 0 || Number(str) <= 0); 
  }

  const calculateClick = (event) => {   
    event.preventDefault(); // Prevent page refresh

    //Check Waves Input
    setUnitLengthErr(!isValue(unitLength));
    setUnitWidthErr(!isValue(unitWidth));
    setWaveHeightErr(!isValue(waveHeight));
    setWavePeriodErr(!isValue(wavePeriod));
    setEfficiencyErr(!isValue(efficiency));    

    if(isValue(waveHeight) && isValue(wavePeriod))    
    {
      //Calculate Waves
      let waveVel = wavePeriod * 1.56;
      setWaveVelocity(waveVel);
      setWaveLength(waveVel * wavePeriod)
      let wavePwr = Math.round( ((1025 * 9.8 * 9.8 * wavePeriod * waveHeight * waveHeight) / (64 * 3.14) / 1000) * 100) / 100;
      setWavePower(wavePwr);
    }
    
    calculateSolar();    
  };

   const calculateSolar = () => {
    //check Solar input
    setSolarAreaErr(!isValue(solarArea));
    setSolarSqMeterErr(!isValue(solarSqMeter));   
    
    if(isValue(solarArea) && isValue(solarSqMeter))
    {
      let solarPwr = Math.round(solarArea * solarSqMeter * 100) / 100;
      setSolarOutput(solarPwr);
    }
   }

 const resetClick = () => {
  //Input
  setUnitLength('');
  setUnitWidth('');
  setDeckArea('');
  setWaveHeight('');
  setWavePeriod('');
  setEfficiency(eff);

  //Calculated
  setWaveLength("");
  setWaveVelocity("");
  setWavePower("");
  setWmInput("");
  setWmOutput("");
  setWmDaily("");
  setWmAnnual("");  
  setSolarOutput("");
  setTotalDaily("");
  setTotalAnnual("");
  setWmIdle("");
  setWmRatio("");

  //Solar
  setSolarArea(area); 
  setSolarSqMeter(sqm);
  
  //Errors
  setUnitLengthErr("");
  setUnitWidthErr("");
  setWaveHeightErr("");
  setWavePeriodErr("");
  setEfficiencyErr("");    
  setSolarAreaErr(""); 

 }    

  const handleSolarOptionChange = (event) => {
    setSelectedSolar(event.target.value);
  };  

 const options = { 
    minimumFractionDigits: 2,
    maximumFractionDigits: 2 
  };

  return (
  <form onSubmit={calculateClick}>   
    <div>      
      <p className="align_left"> 
        This calculator provides an approximate output for the Wave Mill. <br />
        Enter values into all fields below and click the "Calculate" button. Wave input is calculated using the following formula: <br />
        <p style={{marginLeft: '20px'}}>
          <b> Wave Power = ρ·g²·T·H² / (64·π) / 1000 (kW/m) </b>
        </p>
        To improve overall output, we recommend combining inputs from both wave and solar energy. <br />
        <br />
        The Wave Mill unit offers a spacious deck suitable for multiple customer applications. We propose installing solar panels 2 to 3 meters above the deck to create additional working space underneath.<br />
        <br />
        To calculate solar panel output and add it to the totals, click the <b>"Yes"</b> button and enter values into the "Area" and "Output per Square Meter" fields.<br />
        <p>
        Note 1: The "WM Deck" field shows the maximum available area for solar panels. <br />
        Note 2: Under ideal conditions, a modern solar panel with a surface area of one square meter can produce, on average, between 0.75 and 1 kilowatt-hour (kWh) of electricity per day.
        </p>
  </p> 




        {/* This calculator provides the Wave Mill output approximation. <br />
        Input values into the all fields below and click button "Calculate". <br />   
        To calculate wave input we use this formula <br />
        <p>
          Wave Power = ρ*g²*T*H²/(64*π)/1000, (kW/m)
        </p>  
        To improve overall output, we advise to combine inputs from wave and from solar. <br />
        The Wave Mill unit offers a spacious deck for multiple customer applications. <br />
        We propose to setup solar panels 2 or 3 meters above the deck, to create additional working area under. <br />
        To calculate solar panels output and add it to the totals, click button “yes” and input fields “area” <br />
        and “output per square meter”. <br />
        Note1: Field "WM Deck" shows maximum available area for solar panels <br />
        Note2: In ideal conditions, modern solar panel with a surface area of one square meter can produce, <br />
        on average, between 0.75 and 1 kilowatt-hour (kWh) of electricity per day. <br />        
      </p>        */}
 
      <table  className='display_data'>
        <tr valign="top">
            <th colspan="2">WM unit dimensions</th>           
        </tr>
        <tr>
            <td>Length (m)</td>
            <td className='td_number'>
              <input type='number'
                    step="any"
                    min="0" // A very small positive number                    
                    onChange={e => handleUnitLength(e)}
                    value={unitLength}
                    placeholder="Enter a decimal > 0"
              />
              {unitLengthErr && <span className='warning-input' title='Enter a decimal > 0'>&#x26A0;</span> }
            </td>            
        </tr>
        <tr>
            <td align="left">Width (m)</td>
            <td className='td_number'> 
              <input type='number'
                    step="any"
                    min="0" // A very small positive number                    
                    onChange={e => handleUnitWidth(e)}
                    value={unitWidth}
                    placeholder="Enter a decimal > 0"
              />              
              {unitWidthErr && <span className='warning-input' title='Enter a decimal > 0'>&#x26A0;</span> }                           
            </td>
        </tr>
        <tr valign="top" >
            <th colspan="2">Wave parameters</th>         
        </tr>                 
        <tr>
            <td align="left">Height (m)</td>
            <td className='td_number'>
              <input type='number'
                    step="any"
                    min="0" // A very small positive number
                    onChange={e => setWaveHeight(e.target.value)}
                    value={waveHeight}
                    placeholder="Enter a decimal > 0"
              />                
            {waveHeightErr && <span className='warning-input' title='Enter a decimal > 0'>&#x26A0;</span> }                        
            </td>
        </tr>
        <tr>
            <td align="left">Period (s)</td>
            <td className='td_number'>
              <input type='number'
                    step="any"
                    min="0" // A very small positive number
                    onChange={e => setWavePeriod(e.target.value)}
                    value={wavePeriod}
                    placeholder="Enter a decimal > 0"
              />                
            {wavePeriodErr && <span className='warning-input' title='Enter a decimal > 0'>&#x26A0;</span> }                           
            </td>
        </tr>
        <tr>
            <td align="left">Length (m)</td>
            <td className='td_number'>{Number(waveLength).toLocaleString('en', options)}</td>
        </tr>
        <tr>
            <td align="left">Velocity  (m/s)</td>
            <td className='td_number'>{Number(waveVelocity).toLocaleString('en', options)}</td>
        </tr>
        <tr>
            <td align="left">Wave input, (kW/m) </td>
            <td className='td_number'>{Number(wavePower).toLocaleString('en', options)}</td>
        </tr>        
        <tr valign="top" >
            <th colspan="2">Wave Mill</th>         
        </tr>  
        <tr>
            <td align="left">Length ratio = [Unit length] / [Wave length]
              <Popup trigger={<button type='button' tabIndex='-1' style={{border: '2px solid blue', backgroundColor: 'transparent', borderRadius: '15px', position: 'relative', top: '-7px', left: '0', marginLeft: '10px' }}> 
                <span style={{paddingLeft: '1px', paddingRight: '1px'}}>
                    &#x2139;  
                </span></button>} 
                position="top left">
                {close => (
                  <div style={{width: '500px', backgroundColor: '#F5F5F5', color: 'royalblue', border: '2px solid blue', padding: '10px', borderRadius: '15px'}}>
                    If the wave length is longer than the length of the WM unit, when wave crest leaves the unit, the Wave Mill idles untill the next wave crest aproaches. <br /> 
                    We added [unit length] / [wave length] ratio to the formula to calculate input. The idle time estimate is shown in brackets.
                  </div>
                )}
              </Popup>      
            </td>
            <td className='td_number'>{Number(wmRatio).toLocaleString('en', options)} &nbsp; ({Number(wmIdle).toLocaleString('en', options)}s)</td>
        </tr>           
        <tr>
            <td align="left">Input = [Wave Input, kW/m] X [Width] X [Length ratio]  (kW)</td>
            <td className='td_number'>{Number(wmInput).toLocaleString('en', options)}</td>
        </tr>             
        <tr>
            <td align="left">Efficiency</td>
            <td className='td_number'>
              <input type='number'
                    step="any"
                    min="0" // A very small positive number
                    onChange={e => setEfficiency(e.target.value)}
                    value={efficiency}
                    placeholder="Enter a decimal > 0"
                    align='right'
              />                  
            {efficiencyErr && <span className='warning-input' title='Enter a decimal > 0'>&#x26A0;</span> }                                 
            </td>
        </tr>       
        <tr>
            <td align="left">Output (kWh)</td>
            <td className='td_number'>{Number(wmOutput).toLocaleString('en', options)}</td>
        </tr>                
        <tr>
            <td align="left">Daily (MWh) </td>
            <td className='td_number'>{Number(wmDaily).toLocaleString('en', options)}</td>
        </tr>
        <tr>
            <td align="left">Annual (MWh)</td>
            <td  className='td_number'>{Number(wmAnnual).toLocaleString('en', options)} </td>
        </tr>   
        <tr valign="top" >
            <th colspan="2" >Solar Panels on the deck
            
              <span style={{marginLeft: '22px'}}>
                <input type="radio" name="editList" id="always" value="yes" checked={selectedSolar === 'yes'} onChange={handleSolarOptionChange} />
                <label style={{marginLeft: '3px'}} for="yes">Yes</label>
              </span>
              <span style={{marginLeft: '15px'}}>
                <input type="radio" name="editList" id="never" value="no" checked={selectedSolar === 'no'} onChange={handleSolarOptionChange} />
                <label style={{marginLeft: '3px'}} for="no">No</label>              
              </span>
           </th>
        </tr>       
        {selectedSolar === 'yes' &&  
        <tr>
            <td align="left">WM deck area (m²)</td>
            <td className='td_number'>

              <div class="flex_container" >  
                
                  <button type='button'  onClick={copyToSpArea} >
                      Copy to SP Area
                  </button>  
            
                  <div style={{margin: '0 auto', textAlign:'right', width: '100%'}}>
                    {Number(deckArea).toLocaleString('en', options)}	  
                  </div>                            	                        
              </div>              
            </td>
        </tr>   
        }        
        {selectedSolar === 'yes' &&  
        <tr>
            <td align="left">SP Area (m²)</td>
            <td className='td_number'>
              <input type='number'
                    step="any"
                    min="0" // A very small positive number
                    onChange={e => setSolarArea(e.target.value)}
                    value={solarArea}
                    placeholder="Enter a decimal > 0"
                    align='right'
              />                  
            {solarAreaErr && <span className='warning-input' title='Enter a decimal > 0'>&#x26A0;</span> }                                 
            </td>
        </tr> 
        }   
        {selectedSolar === 'yes' &&  
        <tr>
            <td align="left">Output per sq.m (kW)</td>
            <td className='td_number'>
              <input type='number'
                    step="any"
                    min="0" // A very small positive number
                    onChange={e => setSolarSqMeter(e.target.value)}
                    value={solarSqMeter}
                    placeholder="Enter a decimal > 0"
                    align='right'
              />                  
            {solarSqMeterErr && <span className='warning-input' title='Enter a decimal > 0'>&#x26A0;</span> }                                 
            </td>
        </tr> 
        }                        
        {selectedSolar === 'yes' &&  
        <tr>
            <td align="left">Daily Output (kWh)</td>
            <td className='td_number'>{Number(solarOutput).toLocaleString('en', options)}</td>
        </tr>   
        }
        {selectedSolar === 'yes' &&         
       <tr valign="top" >
            <th colspan="2">Total from wave and solar</th>          
        </tr>   
        }
        {selectedSolar === 'yes' &&         
        <tr>
            <td align="left">Daily (MWh) </td>
            <td className='td_number'>{Number(totalDaily).toLocaleString('en', options)}</td>
        </tr>        
        }
        {selectedSolar === 'yes' &&         
        <tr>
            <td align="left">Annual (MWh)</td>
            <td  className='td_number'>{Number(totalAnnual).toLocaleString('en', options)} </td>        
        </tr>        
        }
      </table>  
      <br />
      <div align="right">
        <button type='button'  onClick={resetClick} style={{textAlign:'center', fontSize: '24px',  borderRadius: '7px'}}>
            Reset
        </button> 

        <button  type='submit' style={{marginLeft: '10px', textAlign:'center', color: 'royalblue', fontSize: '24px', fontWeight: 'bold', borderRadius: '7px', borderColor: 'royalblue'}}>
            Calculate
        </button>        
      </div>                           
    </div>  
  </form> 
  )
}
